import { useState } from 'react';
import { useParams } from 'react-router-dom';

const MODULES = [
    { id: 'rentas', label: '💰 Rentas / Tasas', description: 'Consulta deuda, boletas, planes' },
    { id: 'catastro', label: '🏠 Catastro', description: 'Valuaciones, nomenclatura' },
    { id: 'habilitaciones', label: '🏗️ Habilitaciones', description: 'Comercio, expedientes' },
    { id: 'multas', label: '🚗 Multas', description: 'Tránsito, infracciones' },
    { id: 'reclamos', label: '📝 Reclamos', description: 'Quejas ciudadanas' },
    { id: 'emergencias', label: '🚨 Emergencias', description: 'Protocolo crítico' }
];

export default function BotConfig() {
    const { muniId } = useParams();
    const [enabledModules, setEnabledModules] = useState(['rentas', 'reclamos']);
    const [theme, setTheme] = useState({ primary: '#1976d2' });

    const toggleModule = (moduleId: string) => {
        setEnabledModules(prev =>
            prev.includes(moduleId)
                ? prev.filter(m => m !== moduleId)
                : [...prev, moduleId]
        );
    };

    return (
        <div>
            <div className="page-header">
                <h2>🤖 Configuración del Bot</h2>
                <p style={{ color: 'var(--text-secondary)' }}>
                    Municipio ID: {muniId}
                </p>
            </div>

            <div className="card">
                <h3 style={{ marginBottom: '1rem' }}>Módulos Habilitados</h3>
                <div style={{ display: 'grid', gap: '0.5rem' }}>
                    {MODULES.map(module => (
                        <label
                            key={module.id}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '1rem',
                                padding: '1rem',
                                border: '1px solid var(--border)',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                background: enabledModules.includes(module.id) ? 'var(--bg)' : 'white'
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={enabledModules.includes(module.id)}
                                onChange={() => toggleModule(module.id)}
                            />
                            <div>
                                <strong>{module.label}</strong>
                                <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                                    {module.description}
                                </p>
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className="card">
                <h3 style={{ marginBottom: '1rem' }}>Tema Visual</h3>
                <div className="form-group">
                    <label className="form-label">Color Primario</label>
                    <input
                        type="color"
                        value={theme.primary}
                        onChange={(e) => setTheme({ ...theme, primary: e.target.value })}
                        style={{ width: '60px', height: '40px' }}
                    />
                </div>
            </div>

            <button className="btn btn-primary">
                Guardar Cambios
            </button>
        </div>
    );
}
